
import React from 'react';
const NotFound = () => {
  return (
    <div className="notfound-container">
      <h1 className="notfound-title">404</h1>
      <p className="notfound-message">Oops! Page not found.</p>
      <a className="notfound-link" href="/">Go to Homepage</a>
    </div>
  );
};

export default NotFound;
 
